module.exports = __webpack_public_path__ + "img/9788983945327.a3fe87c7.jpg";